import React from 'react';
import { Divider } from '@material-ui/core';
import TextWithInputs from 'src/pages/reportUsage/common/textWithInputs/TextWithInputs';
import TextWithClicks from 'src/pages/reportUsage/common/textWithClicks/TextWithClicks';
import CustomLabel from 'src/pages/reportUsage/common/customLabel/CustomLabel';
import ItemPrices from '../ItemPrices';
import edit from 'src/assets/images/Edit.svg';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import AlertMsg from 'src/pages/reportUsage/common/AlertMsg';
import LotSerialQtyInput from '../LotSerialQtyInput';
import {
    StyledTextDiv,
    ExpandCollapseIcon,
} from 'src/pages/reportUsage/utils/reportUsage.styled';
import collapseIcon from 'src/assets/images/SmallDownArrow.svg';
import Grid from '@material-ui/core/Grid';
import { sizes } from 'src/styles/Media.styled';
import styled from 'styled-components';
import { isMobileDevice, logErrorToConsole } from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import { useRef } from 'react';
import { BROWN_FONT_COLOR, SEMANTIC_TEXT_SMALL_PX, X_SMALL_TEXT_PX } from 'src/styles/fonts/MCFontConstants';

const ItemTemplateMobile = ({
    classes,
    isChildItem,
    item,
    index,
    editItem,
    editedItemList,
    addSerialNumber,
    lotSerialValueEntered,
    onAccountOwnedSeleted,
    deleteItem,
    displayPrice,
    showBundlefromTableList,
    bundleExpandCollapseIconClickHandler,
    isFromReportScreen,
    vendorCaseErrorRedirection,
    onIsSerialUnknown,
   
}) => {
    const { t } = useTranslation();
    const mediaSizes = {
        titleArea: 6,
        buttonnsArea: 6,
        xs: 3,
        lg: 2,
    };
const childRef = useRef(null);
    return (
        <>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                }}
            >
                <Grid lg={12} md={6} sm={6} xs={12}>
                    <div style={{ display: 'flex', paddingRight: '5px' }}>
                        {isFromReportScreen && (
                            <Checkbox
                                checked={item.cfn}
                                id="reportUsage-record-itemsList-ItemListContainerMobile-FromReportScreen"
                                margin={'0px 5px 10px 1px'}
                                labelStyleObj={{
                                    fontSize: SEMANTIC_TEXT_SMALL_PX,
                                    color: BROWN_FONT_COLOR,
                                }}
                                background={'none'}
                                checkboxBorder={'1.5px solid #555555'}
                                alignItemDirection={'center'}
                                hoverEffect={'false'}
                                disableFocusEffect={'true'}
                            />
                        )}
                        {!isChildItem && item.isBundleItem && (
                            <ExpandCollapseIcon
                                src={collapseIcon}
                                alt="down-arrow"
                                isExpanded={item.isBundleExpanded}
                                iconMarginTop={'4px'}
                                width="20px"
                                height="20px"
                                id={`expandCollapseIcon-${item.cfn}-${index}`}
                                onClick={(e) =>
                                    bundleExpandCollapseIconClickHandler(
                                        e,
                                        item,
                                        index
                                    )
                                }
                            />
                        )}
                        {item.isEditable ||
                        (item.isInvalidItemMsg ===
                            t(
                                'reportUsage.procedure.unidSurgery.SurgeryOrReport.ProductNotfound'
                            ) &&
                            !item.isBundleItem) ? (
                            <TextWithInputs
                                type="text"
                                name="cfn"
                                autoFocus={true}
                                defaultValue={item.cfn ? item.cfn : ''}
                                onkeyUp={(e) => editedItemList(e, item, index)}
                                inputHeight={'40px'}
                                inputBorder={
                                    item.isInvalidItemMsg
                                        ? '2px solid #FACFD9'
                                        : '2px solid #EBEDED'
                                }
                                inputWidth={
                                    isChildItem
                                        ? window.innerWidth <=
                                          sizes.mobileDevice
                                            ? 'calc(100vw - 120px)'
                                            : window.innerWidth <=
                                              sizes.smalDevice
                                            ? '265px'
                                            : '300px'
                                        : item.isBundleItem
                                        ? window.innerWidth <=
                                          sizes.mobileDevice
                                            ? 'calc(100vw - 93px)'
                                            : window.innerWidth <=
                                              sizes.smalDevice
                                            ? '285px'
                                            : '315px'
                                        : window.innerWidth <=
                                          sizes.mobileDevice
                                        ? 'calc(100vw - 67px)'
                                        : window.innerWidth <= sizes.smalDevice
                                        ? '280px'
                                        : '320px'
                                }
                                marginBottom={'5px'}
                            />
                        ) : isFromReportScreen ? (
                            <div
                                style={{
                                    display: 'flex',
                                }}
                            >
                                <TextWithClicks
                                    style={{
                                        marginLeft: '10px',
                                    }}
                                    classes={classes}
                                    media={mediaSizes}
                                    leftTitle={item.cfn}
                                    typeNonTissue={
                                        !item.isBundleItem &&
                                        (item.salesOrg === 'S002'
                                            ? 'NT'
                                            : item.salesOrg === 'S030'
                                            ? 'T'
                                            : undefined)
                                    }
                                    typeEA={!item.isBundleItem && item.uom}
                                    alignItemsVal={'flex-start'}
                                    justifyContentVal={
                                        isMobileDevice() && window.orientation === 0
                                            ? 'flex-end'
                                            : 'flex-start'
                                    }
                                    editMarginLeft={
                                        item.isBundleItem
                                            ? '5px'
                                            : !item.uom &&
                                              !item.salesOrg &&
                                              !item.isBundleItem &&
                                              '60px'
                                    }
                                    typeBundle={item.isBundleItem && 'BUNDLE'}
                                />
                            </div>
                        ) : (
                            <TextWithClicks
                                classes={classes}
                                media={mediaSizes}
                                leftTitle={item.cfn}
                                alignItems={'center'}
                                typeNonTissue={
                                    !item.isBundleItem &&
                                    (item.salesOrg === 'S002'
                                        ? 'NT'
                                        : item.salesOrg === 'S030'
                                        ? 'T'
                                        : undefined)
                                }
                                typeEA={!item.isBundleItem && item.uom}
                                buttonImg={edit}
                                editAction={() => editItem(item, index)}
                                alignItemsVal={'center'}
                                justifyContentVal={
                                    isMobileDevice() && window.orientation === 0 ? 'flex-end' : 'flex-start'
                                }
                                editMarginLeft={isChildItem ? '10px' : '20px'}
                                typeBundle={item.isBundleItem && 'BUNDLE'}
                            />
                        )}
                    </div>
                    {!item.isEditable && item.description && (
                        <CustomLabel
                            fSize={'12px !important'}
                            color={'#140F4B'}
                            label={item.description}
                            maxWidth={'78%'}
                            paddingBottom={'10px'}
                            letterSpacing={'0px'}
                            opacity={0.7}
                            fontFamily={'AvenirNextWorld Regular'}
                            paddingLeft={
                                item.isBundleItem && !isChildItem && '25px'
                            }
                        />
                    )}
                    {item.isInvalidItemMsg && (
                        <div
                            style={{
                                display: 'flex',
                                paddingLeft:
                                    item.isBundleItem && !isChildItem && '25px',
                                paddingBottom: '20px',
                            }}
                        >
                            <AlertMsg message={item.isInvalidItemMsg} />
                        </div>
                    )}
                </Grid>
                <Grid
                    lg={12}
                    md={6}
                    sm={6}
                    xs={12}
                    style={{
                        marginLeft: !isMobileDevice() ? '0px' : 'unset',
                    }}
                >
                    {item.lotSerial &&
                        item.lotSerial.map((lotItem, lotItemIdx) => {
                            return (
                                <LotSerialQtyInput
                                    key={`${index} ${lotItemIdx}`}
                                    isFromReportScreen={isFromReportScreen}
                                    isChildItem={isChildItem}
                                    item={item}
                                    index={index}
                                    lotItem={lotItem}
                                    lotItemIdx={lotItemIdx}
                                    addSerialNumber={addSerialNumber}
                                    lotSerialValueEntered={
                                        lotSerialValueEntered
                                    }
                                    deleteItem={deleteItem}
                                    showTopLabel
                                    showBundlefromTableList={
                                        showBundlefromTableList
                                    }
                                    isFromMobileView
                                    childIdx={index}
                                    vendorCaseErrorRedirection={
                                        vendorCaseErrorRedirection
                                    }
                                    onIsSerialUnknown={onIsSerialUnknown}
                                    ref={childRef}
                                />
                            );
                        })}
                    {/* removed as a part of defect 21622 */}
                    {/* {
                        <div>
                            {' '}
                            <CustomLabel
                                fSize={'13px!important'}
                                fontFamily={'AvenirNextWorld Regular'}
                                color="#1010EB"
                                cursor={'pointer'}
                                width={'30%'}
                                opacity={1}
                                label={`${'+'}${t('reportUsage.itemList.lotorserial')}`}
                                onLabelClick={() => {
                                    try {
                                        if (childRef.current) {
                                            childRef.current.bottomLabelClickHandler();
                                        }
                                    } catch (error) {
                                        logErrorToConsole(error);
                                    }
                                }}
                                paddingTop={'0px'}
                                paddingLeft={'0px'}
                                letterSpacing={'-0.11px'}
                                fWeight={'normal'}
                            />
                        </div>
                    } */}
                </Grid>
            </div>
            {!item.isInvalidItemMsg &&
                (item.isBundleItem ? (
                    <>
                        <StyledDivItemTemplate
                            width={'100%'}
                            display={'flex'}
                            justifyContent={'space-between'}
                            padding={
                                window.innerWidth <= sizes.mobileDevice
                                    ? '0 12px 0 8px'
                                    : ''
                            }
                        >
                            <CustomLabel
                                fSize={'12px !important'}
                                color="#1010EB"
                                cursor={'pointer'}
                                opacity={1}
                                label={t(
                                    'reportUsage.record.itemsList.ItemListContainerMobile.addItems'
                                )}
                                onLabelClick={() =>
                                    showBundlefromTableList(
                                        true,
                                        index,
                                        item.cfn,
                                        item?.unqId
                                    )
                                }
                                width={'77px'}
                                letterSpacing={'-0.11px'}
                            />
                            {item.basePrice && (
                                <>
                                    <StyledTextDiv
                                    isUnitPriceLabel = {true}
                                     padding={
                                        isMobileDevice()
                                            ? '10px 10px 10px 0px'
                                            : '10px 0px 10px 160px' 
                                    }
                                    >
                                        {t(
                                            'reportUsage.record.itemsList.ItemListContainerMobile.unitPrice'
                                        )}
                                    </StyledTextDiv>
                                    <StyledTextDiv
                                    padding={
                                        isMobileDevice()
                                            ? '10px 0'
                                            : '10px 0px 10px 0px '
                                    }
                                    >
                                        {t(
                                            'reportUsage.record.itemsList.ItemListContainerMobile.extPrice'
                                        )}
                                    </StyledTextDiv>{' '}
                                </>
                            )}
                        </StyledDivItemTemplate>
                        <div style={{ padding: '8px 0' }}>
                            <Divider orientation="horizontal" />
                        </div>
                        <ItemPrices
                            classes={classes}
                            item={item}
                            displayPrice={displayPrice}
                            isFromMobileView
                            isBundleItem={item.isBundleItem}
                            index={index}
                            showBundlefromTableList={showBundlefromTableList}
                        />
                    </>
                ) : (
                    item.basePrice &&
                    !isChildItem &&
                    !isFromReportScreen && (
                        <>
                            <StyledDivItemTemplate
                                width={'100%'}
                                display={'flex'}
                                justifyContent={'space-between'}
                                padding={
                                    window.innerWidth <= sizes.mobileDevice
                                        ? '10px 12px 0 2px'
                                        : ''
                                }
                            >
                                <StyledCheckboxText>
                                    <Checkbox
                                        label={t(
                                            'reportUsage.record.itemsList.ItemListContainerMobile.accountOwned'
                                        )}
                                        checked={item.accountOwned}
                                        onCheckboxSelectionChange={() =>
                                            onAccountOwnedSeleted(item, index)
                                        }
                                        id="reportUsage-record-itemsList-ItemListContainerMobile-accountOwned"
                                        margin={'0px 8px 0px 0px'}
                                        labelStyleObj={{
                                            fontSize: X_SMALL_TEXT_PX,
                                            color: BROWN_FONT_COLOR,
                                        }}
                                        background={'none'}
                                        checkboxBorder={'1.5px solid #555555'}
                                        alignItemDirection={'center'}
                                        hoverEffect={'false'}
                                        disableFocusEffect={'true'}
                                    />
                                </StyledCheckboxText>

                                <StyledTextDiv
                                  isUnitPriceLabel={true}
                                    padding={
                                        isMobileDevice()
                                            ? '10px 10px 10px 0px'
                                            : '10px 0px 10px 160px'
                                    }
                                >
                                    {t(
                                        'reportUsage.record.itemsList.ItemListContainerMobile.unitPrice'
                                    )}
                                </StyledTextDiv>
                                <StyledTextDiv
                                    padding={
                                        isMobileDevice()
                                            ? '10px 0'
                                            : '10px 0px 10px 0px '
                                    }
                                >
                                    {t(
                                        'reportUsage.record.itemsList.ItemListContainerMobile.extPrice'
                                    )}
                                </StyledTextDiv>
                            </StyledDivItemTemplate>
                            <div style={{ padding: '8px 0' }}>
                                <Divider orientation="horizontal" />
                            </div>
                            <ItemPrices
                                classes={classes}
                                item={item}
                                displayPrice={displayPrice}
                                isFromMobileView
                                isFromReportScreen={isFromReportScreen}
                            />
                        </>
                    )
                ))}
        </>
    );
};

export default ItemTemplateMobile;

const StyledCheckboxText = styled.div`
    width: 100px;
    line-height: 1.3;
    margin-top: 8px;
`;

const StyledDivItemTemplate = styled.div`
    width: ${({ width }) => width};
    display: ${({ display }) => display};
    justify-content: ${({ justifyContent }) => justifyContent};
    padding: ${({ padding }) => padding};
`;
